import {SELF, VERIFIED} from 'src/internal/shared/permissions/symbols';

import type {UnverifiedToken} from 'src/internal/shared/permissions/types';

export type AllPermissions = {
  [Property in keyof globalThis.SailDataPermissions]: true;
};

/**
 * @see https://trailhead.corp.stripe.com/docs/sail-data/api/getUnverifiedToken
 */
export default function getUnverifiedToken(): UnverifiedToken {
  return {
    [SELF]: {},
    [VERIFIED]: false,
  } as unknown as UnverifiedToken;
}
